export default "__VITE_ASSET__Bcadp$J7__"